import CustomCard from "components/Atoms/CustomCard"
import CustomButton from "components/Atoms/CustomButton"
import React from "react"
import { useNavigate } from "react-router-dom"
import ImportStockTransaction from "./import/ImportStockTransaction"

const ImportStockTransactions = () => {
  const navigate = useNavigate()
  return (
    <CustomCard className="m-3 p-0">
      <div className="container flex items-start justify-between p-3">
        <div className="mr-3 flex">
          <CustomButton
            className="mr-3"
            minimal
            icon="arrow-left"
            onClick={() => navigate(-1)}
          />
          <h6 className="my-0 self-center">
            Import stock transactions via excel file
          </h6>
        </div>
      </div>
      {/* TODO: Reuse the existing MultipleDemands in future */}
      <ImportStockTransaction />
    </CustomCard>
  )
}

export default ImportStockTransactions
